import React from 'react';

import ThemesContainer from './ThemesContainer/ThemesContainer';

export default (props: any) => <ThemesContainer {...props} detail={true} />;
